// extracted by mini-css-extract-plugin
module.exports = {"participant-name":"ParticipantResults_participant-name__1Ov9o"};